// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__37Bhb","detailsBorder":"styles_detailsBorder__3p6sE"};